import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const postMultiQuizImages = (data, customConfig) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.POST_MULTI_QUIZ_IMAGES,
    data,
    null,
    customConfig
  );
};

export default postMultiQuizImages;
